'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ID = exports.ID = ['id'];
var OBJECT_TYPE = exports.OBJECT_TYPE = ['objectType'];
var OBJECT_ID = exports.OBJECT_ID = ['objectId'];
var OBJECT_NAME = exports.OBJECT_NAME = ['objectName'];
var UPDATE = exports.UPDATE = ['update'];
var TIMESTAMP = exports.TIMESTAMP = ['timestamp'];
var SOURCE = exports.SOURCE = ['source'];
var SOURCE_ID = exports.SOURCE_ID = ['sourceId'];

var UPDATE_TYPE = exports.UPDATE_TYPE = ['@type'];
var PIPELINE_ID = exports.PIPELINE_ID = ['pipelineId'];
var PIPELINE_NAME = exports.PIPELINE_NAME = ['pipelineName'];
var PIPELINE_STAGE_ID = exports.PIPELINE_STAGE_ID = ['pipelineStageId'];
var PIPELINE_STAGE = exports.PIPELINE_STAGE = ['pipelineStage'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/crm-object-lifecycle-update/constants/keyPaths.js
// module id = 752
// module chunks = 2 3